import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DateTime from '_class/DateTime';
import ColorScale from '_class/ColorScale';
import { getRootUrl } from 'helpers/url';

import { getSectionAssessmentStatistics } from 'actions/sections';

import { Spinner, Collapsible } from 'UI';
import { Bar, Progress } from 'UI/Graphs';
import { Block, Checkbox, Icon, MultiSelect, Table, translate } from '@haldor/ui';
import './UserSection.scss'
import DisplayName from 'components/Presentation/DisplayName';
import { Stack, Tooltip } from '@mui/material';
import moment from 'moment';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';

class UserSection extends Component {

	constructor(props) {
		super(props);

		this.state = {
			filters: ['ASSESSMENTGOAL', 'MATRIX', 'ASSESSED-ASSIGNED'],
			subjects: [],
			openStudents: [],
			loadingAssessments: false,
			width: 0,
			showMenu: true,
		};

		this.container = null;
		this.barColumn = null;
	}

	_setContainer = (element) => this.container = element;
	_setBarColumn = (element) => this.barColumn = element;

	componentDidMount = () => {
		window.addEventListener('hashchange', this.onHashChange);
		window.addEventListener('resize', this.resize);
		this.setState({ openStudents: this.props.group.members.map(student => student.userId) }, () => {
			this.resize();
		});
	}

	componentWillUnmount = () => {
		window.removeEventListener('resize', this.resize);
		window.removeEventListener('hashchange', this.onHashChange);
	}

	componentDidUpdate(prevProps) {
		// Check if start or end has changed
		if ((prevProps.start !== this.props.start || prevProps.end !== this.props.end) && this.state.subjects.length > 0) {
			this.fetchAssessmentStatistics(this.state.subjects);
		}
	}

	onHashChange = () => {
		if (window.location.hash == '#assessments') {
			this.setState({ showMenu: true })
		} else {
			this.setState({ showMenu: false })
		}
	}

	resize = () => {
		if (this.barColumn != null && this.container != null) {
			this.setState({ width: this.container.scrollWidth - this.barColumn.scrollWidth })
		}
	}

	toggleStudentOpen = (student) => {
		const index = this.state.openStudents.indexOf(student.userId);

		if (index > -1) {
			this.setState({ openStudents: this.state.openStudents.filter(id => id != student.userId) });
		} else {
			this.setState({ openStudents: [...this.state.openStudents, student.userId] });
		}
	}

	toggleStudentsOpen = () => {
		const active = this.props.group.members.length == this.state.openStudents.length;

		if (active) {
			this.setState({ openStudents: [] });
		} else {
			this.setState({ openStudents: this.props.group.members.map(student => student.userId) });
		}
	}

	toggleFilter = (filter) => {
		const index = this.state.filters.indexOf(filter);

		if (index > -1) {
			this.setState({ filters: this.state.filters.filter(id => id != filter) });
		} else {
			this.setState({ filters: [...this.state.filters, filter] });
		}
	}

	fetchAssessmentStatistics = (subjects) => {
		const { group, start, end } = this.props;
		this.setState({ loadingAssessments: true });
		this.props.getSectionAssessmentStatistics(group.id, start, end, subjects).then(() => {
			this.setState({ loadingAssessments: false });
		});
	}

	onSubjectsChange = (subjects) => {
		this.setState({ subjects });
		this.fetchAssessmentStatistics(subjects);
	}

	getPercentageFromStatistics = (items) => {
		if (items == null) {
			return 0;
		}

		let percentages = [];

		items.forEach((item) => {
			let item_total = 0;
			let indexed = [];

			item.statistics.forEach((stat) => {
				item_total += stat.count;
				indexed.push({ count: stat.count, index: stat.index, weight: stat.weight });
			});

			for (let i = 0; i <= item_total; i++) {
				indexed.map((entry) => {
					if (entry.count > 0) {
						percentages.push(entry.weight);
						entry.count = entry.count - 1;
					}

					return entry;
				});
			}
		});

		return Math.round(percentages.reduce((a, b) => a + b, 0) / percentages.length);
	}

	renderAssessmentBar = (item, index) => {
		if (!this.state.filters.includes(item.type)) {
			return null;
		}

		if (item.statistics != null) {
			var data = [];
			const isEmpty = item.statistics.find((stat) => stat.count > 0) == null;

			if (isEmpty) {
				return null;
			}

			const colors = new ColorScale(item.statistics.length).get();
			item.statistics.map((stat) => {
				data.push({
					amount: stat.count,
					label: stat.count,
					color: colors[stat.index],
				});
			});

			let line = null;
			if (data.length > 0) {
				line = (
					<Bar data={data} showAmount showAllSteps />
				);
			}

			return (
				<div key={index} className="bar-outer-container">
					<div>
						{this.props.translate(item.type)}
					</div>

					{line}
				</div>
			);
		}
		return <div />;
	}

	getChildHistoricMembers = (historicMember) => {
		const children = this.props.group.historicMembers.filter(el =>
			el.userId == historicMember.userId && el.relationship == 'child'
		);

		return children.map((member) => {
			return (
				<div className="history-member-row child">
					<div style={{ flex: 1 }} className="name">
					</div>

					<div className="connected-duration">
						<span>
							{`${new DateTime(member.startDate).getDateStamp()} - ${new DateTime(member.endDate).getDateStamp()}`}
						</span>

						{member.userRoles.some(el => el.toUpperCase() == 'OWNER') ?
							<div className="card-meta" style={{ marginLeft: '1.65rem', fontWeight: 500 }}>
								{this.props.translate('Owner')}
							</div>
							: null}
					</div>
				</div>
			);
		});
	}

	renderStudentRecentlyAdded = (student) => {
		if (student == null) {
			return null;
		}

		if (student.connectedToSectionDate != null) {

			const endDate = moment(student.connectedToSectionDate);
			const today = moment();
			const sevenDaysAgo = moment().subtract(7, 'days');
			var recentlyAdded = endDate.isBetween(sevenDaysAgo, today, null, '[]');

			if (recentlyAdded) {
				return (
					<Tooltip title={this.props.translate('Connected to group') + ' ' + new DateTime(student.connectedToSectionDate).getDateStamp()} placement="top" arrow>
						<ErrorRoundedIcon style={{ height: '1.2rem', color: 'var(--color--blue)' }} />
					</Tooltip>
				);
			}
		}

		return null;
	}

	renderStudentRoleIndicator = (student) => {
		if (student == null) {
			return null;
		}

		if (student.userRoles != null && !student.userRoles.some(ur => ur.toUpperCase() == 'STUDENT')) {
			const { translate } = this.props;

			return (
				<Tooltip title={translate('Missing student role in school')} placement="top" arrow>
					<ErrorRoundedIcon style={{ height: '1.2rem', color: 'rgb(245, 93, 110)' }} />
				</Tooltip>
			);
		}

		return null;
	};

	renderGoalBar = (percentage = 0) => {
		if (!this.state.filters.includes('ASSESSMENTGOAL')) {
			return null;
		}

		if (percentage == 0) {
			return null;
		}

		return (
			<div className="bar-outer-container">
				<div>
					{this.props.translate('ASSESSMENTGOAL')}
				</div>

				<div style={{ paddingLeft: '.55rem' }}>
					<Progress percentage={percentage} label={`${percentage}%`} />
				</div>
			</div>
		);
	}

	renderAssessedAndAssignedInfo = (item) => {
		if (item == null) return;

		if (!this.state.filters.includes('ASSESSED-ASSIGNED')) {
			return null;
		}

		var title = `${item.totalAssessedAssignments + item.totalAssessedPlannings} ${this.props.translate('of')} ${item.totalAssignedAssignments + item.totalAssignedPlannings} ${this.props.translate('plans and assignments in all subjects')}`

		return (
			<div className="bar-outer-container">
				<div>
					{this.props.translate("Assessed-Assigned")}
				</div>

				<div style={{ paddingLeft: '.55rem' }}>
					<Progress labelPostion='start' currentValue={item.totalAssessedAssignments + item.totalAssessedPlannings} maxValue={item.totalAssignedAssignments + item.totalAssignedPlannings} label={title} />
				</div>
			</div>
		);
	}


	renderTable = () => {
		const width = this.state.width > 0 ? this.state.width + 'px' : '100%';
		const sortedStudents = this.props.group?.members != null ? this.props.group?.members.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || "")) : [];

		return <Table>
			<thead>
				<tr>
					<th ref={this._setBarColumn}>
						{this.props.translate('name')}
					</th>

					<th style={{ width }}>
						{this.props.translate('assessment-overview')}
					</th>
				</tr>
			</thead>

			<tbody>
				{sortedStudents.map((student) => {
					let studentStatistics = null;
					let percentage = 0;
					const open = this.state.openStudents.includes(student.userId);

					if (this.props.statistics != null) {
						studentStatistics = this.props.statistics.find((item) => {
							return item.studentId == student.userId;
						});

						const goalStatistics = studentStatistics?.studentStatistics?.filter(stat => stat.type == 'ASSESSMENTGOAL');
						percentage = this.getPercentageFromStatistics(goalStatistics);
					}

					return (
						<tr key={student.id}>
							<td className='name'>
								<Link to={`${getRootUrl()}groups/${this.props.group.id}/progress/${student.id}`}>
									<Stack direction="row">
										{this.renderStudentRoleIndicator(student)}
										{this.renderStudentRecentlyAdded(student)}
									</Stack>

									<DisplayName
										firstName={student.firstName}
										lastName={student.lastName}
										email={student.email}
										data={sortedStudents}
										tooltipTile={student.connectedToSectionDate != null ? this.props.translate('Connected to group') + ' ' + new DateTime(student.connectedToSectionDate).getDateStamp() : null}
									/>
								</Link>
							</td>

							<td className="assessment-bar">
								{this.renderAssessedAndAssignedInfo(studentStatistics)}

								{percentage > 0 ?
									this.renderGoalBar(percentage)
									: null}

								{studentStatistics != null ?
									studentStatistics.studentStatistics.map((item, index) => {
										if (item.type == 'MATRIX') {
											return this.renderAssessmentBar(item, index);
										}

										return null;
									})
									: <div style={{ height: 23 }} />}
							</td>
						</tr>
					);
				})}
			</tbody>
		</Table >
	}

	render() {
		this.props.group.historicMembers?.forEach((member, index) => {
			var laterEntries = this.props.group.historicMembers.some((el, someIndex) => el.userId == member.userId && someIndex > index);
			var earlierEntries = this.props.group.historicMembers.some((el, someIndex) => el.userId == member.userId && someIndex < index);
			if (laterEntries && !earlierEntries) {
				member.relationship = 'parent';
			} else if ((laterEntries && earlierEntries) || (!laterEntries && earlierEntries)) {
				member.relationship = 'child';
			} else {
				member.relationship = null;
			}
		});

		let subjects = this.props.subjects ?? [];

		if (subjects != null && subjects.find((subject) => subject.id == 0) == null) {
			subjects.push({ id: 0, title: this.props.translate('Assessments without subjects') })
		}

		let membersRecentlyLeft = this.props.group.historicMembers?.some((member) => {
			const endDate = moment(member.endDate);
			const today = moment();
			const sevenDaysAgo = moment().subtract(7, 'days');
			return endDate.isBetween(sevenDaysAgo, today, null, '[]');
		});

		let multipleDropDown = null;

		if (this.state.subjects != null && subjects != null && subjects.length > 0) {
			multipleDropDown = <div style={{ display: 'flex', alignItems: 'center' }}>{this.props.translate('Showing') + ' ' + this.state.subjects.length + ' ' + this.props.translate('of') + ' ' + subjects.length + ' ' + this.props.translate('subjects')} <ArrowDropDownOutlinedIcon style={{ marginLeft: '.3rem' }}></ArrowDropDownOutlinedIcon></div>
		}
		return (
			<div ref={this._setContainer} className="list user-mentor">

				<Block>
					<div className="title-container">
						<span className="title" style={{ marginBottom: 0 }}>
							{this.props.translate('Students')}
						</span>
						{this.state.showMenu ?
							<div className="filter-container">
								{this.state.loadingAssessments ?
									<Spinner small />
									: null}


								<Checkbox
									label={this.props.translate('Show the number of Assessed-Assigned')}
									onChange={() => this.toggleFilter('ASSESSED-ASSIGNED')}
									value={this.state.filters.includes('ASSESSED-ASSIGNED')}
								/>

								<Checkbox
									label={this.props.translate('MATRIX')}
									onChange={() => this.toggleFilter('MATRIX')}
									value={this.state.filters.includes('MATRIX')}
								/>

								<Checkbox
									label={this.props.translate('ASSESSMENTGOAL')}
									onChange={() => this.toggleFilter('ASSESSMENTGOAL')}
									value={this.state.filters.includes('ASSESSMENTGOAL')}
								/>

								{multipleDropDown != null && this.props.subjects != null ?
									<MultiSelect
										style={{ marginRight: '0rem' }}
										displaySelectedCount={false}
										trigger={multipleDropDown}
										options={subjects.sort((a, b) => a.title.localeCompare(b.title)).map((subject) => ({
											label: subject.title + (subject.subjectCode != null ? ' - ' + subject.subjectCode : ''),
											value: subject.id,
										}))}
										value={subjects.map((subject) => subject.id)}
										onChange={this.onSubjectsChange}
										selectAllLabel={this.props.translate('Select all')}
									/>
									: null}
							</div>
							: null}
					</div>

					<div style={{ position: 'relative', margin: '0 -1.7rem' }}>
						{this.renderTable()}
					</div>

					{this.props.group.historicMembers && this.props.group.historicMembers.length > 0 &&
						<div className="previous-members-card">
							<Collapsible trigger={(
								<div className="previous-members-title"> {membersRecentlyLeft ? <ErrorRoundedIcon style={{ color: 'var(--color--blue)' }} /> : null} {this.props.translate('Previous members')}</div>
							)}>
								<div className="previous-member-list">
									{this.props.group.historicMembers?.map((student) => {
										let memberLeftRecently = false;

										if (student.endDate != null) {
											const endDate = moment(student.endDate);
											const today = moment();
											const sevenDaysAgo = moment().subtract(7, 'days');
											memberLeftRecently = endDate.isBetween(sevenDaysAgo, today, null, '[]');
										}

										return (
											<div>
												{student.relationship == 'parent' ?
													<Collapsible trigger={(
														<div className="history-member-row">

															<Stack
																direction="row"
																spacing={0.5}
																sx={{
																	justifyContent: "flex-start",
																	alignItems: "center",
																}}
															>
																{memberLeftRecently ? <Tooltip title={this.props.translate('Left the group') + ' ' + moment.utc(student.endDate).local().format('YYYY-MM-DD')} placement="top" arrow>
																	<ErrorRoundedIcon style={{ color: 'var(--color--blue)' }} />
																</Tooltip> : null}

																<Tooltip title={this.props.translate('Left the group') + ' ' + moment.utc(student.endDate).local().format('YYYY-MM-DD')} placement="top" arrow>
																	<span>{student.displayName}</span>
																</Tooltip>

															</Stack>
															<div className="connected-duration">
																<span>{`${new DateTime(student.startDate).getDateStamp()} - ${new DateTime(student.endDate).getDateStamp()}`}</span>
																{student.userRoles.some(el => el == 'OWNER') ?
																	<div className="card-meta" style={{ marginLeft: '1.65rem', fontWeight: 500 }}>
																		{this.props.translate('Owner')}
																	</div>
																	: null
																}
															</div>
														</div>
													)}>
														{this.getChildHistoricMembers(student)}
													</Collapsible>
													:
													student.relationship == null ?
														<div className="history-member-row child">
															<div style={{ flex: 1 }} className="name">

																<Stack
																	direction="row"
																	spacing={0.5}
																	sx={{
																		justifyContent: "flex-start",
																		alignItems: "center",
																	}}
																>
																	{memberLeftRecently ? <Tooltip title={this.props.translate('Left the group') + ' ' + moment.utc(student.endDate).local().format('YYYY-MM-DD')} placement="top" arrow>
																		<ErrorRoundedIcon style={{ color: 'var(--color--blue)' }} />
																	</Tooltip> : null}

																	<Tooltip title={this.props.translate('Left the group') + ' ' + moment.utc(student.endDate).local().format('YYYY-MM-DD')} placement="top" arrow>
																		<span>{student.displayName}</span>
																	</Tooltip>

																</Stack>
															</div>

															<div className="connected-duration">
																{`${new DateTime(student.startDate).getDateStamp()} - ${new DateTime(student.endDate).getDateStamp()}`}
															</div>
														</div>
														: null
												}
											</div>
										);
									})}
								</div>
							</Collapsible>
						</div>
					}
				</Block>
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		statistics: state.sections.assessmentStatistics,
		subjects: state.Subjects.section,
	};
}

export default connect(mapStateToProps, {
	getSectionAssessmentStatistics,
})(UserSection);
